module.exports = __webpack_public_path__ + "img/warning.fe5bbae6.png";